import React from "react";
import { empowerWho } from "../mock";
import Reveal from "./Reveal";

const colors = { blue: "#187EE4", orange: "#FF6C10", red: "#FF1228" };

const EmpowerWho = () => {
  return (
    <section className="bg-white pb-10 md:pb-16 pt-4">
      <div className="max-w-6xl mx-auto px-5 md:px-8">
        <Reveal>
          <div className="text-center mb-10">
            <h2 className="font-display text-3xl md:text-5xl" style={{ color: "#187EE4" }}>{empowerWho.title}</h2>
          </div>
        </Reveal>

        <div className="grid md:grid-cols-3 gap-6">
          {empowerWho.items.map((it, i) => {
            const color = colors[it.color];
            return (
              <Reveal key={it.id} delay={i * 110}>
                <div
                  className="h-full rounded-[28px] bg-white shadow-md hover:shadow-xl hover:-translate-y-1 transition-all duration-300 border border-slate-100 border-t-4 overflow-hidden"
                  style={{ borderTopColor: color }}
                  data-testid={`empower-card-${it.id}`}
                >
                  <div className="aspect-[16/10] overflow-hidden bg-slate-100">
                    <img src={it.image} alt={it.title} className="w-full h-full object-cover" />
                  </div>
                  <div className="p-6 text-center">
                    <h3 className="font-display text-2xl md:text-3xl" style={{ color }}>{it.title}</h3>
                    <p className="mt-3 text-slate-600 font-medium leading-relaxed text-sm md:text-base">{it.body}</p>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default EmpowerWho;
